import { render, staticRenderFns } from "./LeaveRecordsList.vue?vue&type=template&id=4951d288&scoped=true&"
import script from "./LeaveRecordsList.vue?vue&type=script&lang=js&"
export * from "./LeaveRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRecordsList.vue?vue&type=style&index=0&id=4951d288&lang=scss&scoped=true&"
import style1 from "./LeaveRecordsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951d288",
  null
  
)

export default component.exports